import React, { useState, useEffect } from 'react';

function CollaborativeCursors({ onlineUsers, currentUser, containerRef }) {
  const [cursors, setCursors] = useState({});

  useEffect(() => {
    // Filter out current user and users without cursor data
    const otherUserCursors = onlineUsers
      .filter(user => 
        user.user_id !== currentUser?.id && 
        user.cursor_position?.x !== undefined
      )
      .reduce((acc, user) => {
        acc[user.user_id] = {
          ...user,
          x: user.cursor_position.x,
          y: user.cursor_position.y
        };
        return acc;
      }, {});

    setCursors(otherUserCursors);
  }, [onlineUsers, currentUser]);

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      pointerEvents: 'none', 
      zIndex: 9998 
    }}>
      {Object.values(cursors).map(user => (
        <div
          key={user.user_id}
          style={{
            position: 'absolute',
            left: user.x,
            top: user.y,
            transform: 'translate(-50%, -50%)',
            transition: 'all 0.1s ease-out',
            zIndex: 9999
          }}
        >
          {/* Cursor */}
          <div style={{
            width: '0',
            height: '0',
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderBottom: `16px solid ${getUserColor(user.user_email)}`,
            transform: 'rotate(-45deg)',
            marginBottom: '8px'
          }} />
          
          {/* User label */}
          <div style={{
            backgroundColor: getUserColor(user.user_email),
            color: 'white',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '11px',
            fontWeight: '500',
            whiteSpace: 'nowrap',
            marginTop: '4px',
            marginLeft: '8px'
          }}>
            {user.user_name || user.user_email}
          </div>
        </div>
      ))}
    </div>
  );
}

// Helper function (same as before)
function getUserColor(email) {
  const colors = ['#007bff', '#28a745', '#dc3545', '#ffc107', '#17a2b8', '#6f42c1'];
  const hash = email.split('').reduce((a, b) => {
    a = ((a << 5) - a) + b.charCodeAt(0);
    return a & a;
  }, 0);
  return colors[Math.abs(hash) % colors.length];
}

export default CollaborativeCursors;
